var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _g4, _g5, _ellipse, _path6, _path7, _path8, _path9, _g6, _g7, _ellipse2, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 175C59.1775 175 25.6001 141.423 25.6001 100C25.6001 58.5774 59.1775 25 100.6 25C142.023 25 175.6 58.5774 175.6 100C175.6 141.423 142.023 175 100.6 175Z",
    fill: "url(#paint0_linear_26801_925)",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.962 114.435H77.382C74.0491 114.435 71.3472 112.507 71.3472 110.129V90.7535C71.3472 88.3756 74.0491 86.4478 77.382 86.4478H160.962C164.295 86.4478 166.997 88.3756 166.997 90.7535V110.129C166.997 112.507 164.295 114.435 160.962 114.435Z",
    fill: "url(#paint1_linear_26801_925)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2816 110.108V90.7744C80.2816 88.4015 82.2111 86.4779 84.591 86.4779H75.9725C73.5925 86.4779 71.6631 88.4015 71.6631 90.7744V110.108C71.6631 112.481 73.5925 114.404 75.9725 114.404H84.591C82.2109 114.404 80.2816 112.481 80.2816 110.108Z",
    fill: "#D4D9E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5806 86.4779H37.1888C34.8088 86.4779 32.8794 88.4015 32.8794 90.7744V110.108C32.8794 112.481 34.8088 114.404 37.1888 114.404H56.5806C58.9605 114.404 60.89 112.481 60.89 110.108V90.7744C60.89 88.4015 58.9605 86.4779 56.5806 86.4779ZM54.4259 107.96H39.3433V92.9224H54.4259V107.96Z",
    fill: "url(#paint2_linear_26801_925)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.232 96.6345H81.3968C80.5303 96.6345 79.8281 95.9345 79.8281 95.0706C79.8281 94.2067 80.5303 93.5067 81.3968 93.5067H130.232C131.098 93.5067 131.8 94.2067 131.8 95.0706C131.8 95.9345 131.098 96.6345 130.232 96.6345Z",
    fill: "#E8EDFB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.814 107.376H81.3968C80.5303 107.376 79.8281 106.676 79.8281 105.812C79.8281 104.948 80.5303 104.248 81.3968 104.248H105.814C106.681 104.248 107.383 104.948 107.383 105.812C107.383 106.676 106.68 107.376 105.814 107.376Z",
    fill: "#E8EDFB"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.962 75.0457H77.382C74.0491 75.0457 71.3472 73.1179 71.3472 70.74V51.3646C71.3475 48.9866 74.0491 47.0588 77.382 47.0588H160.962C164.295 47.0588 166.997 48.9866 166.997 51.3646V70.74C166.997 73.1179 164.295 75.0457 160.962 75.0457Z",
    fill: "url(#paint3_linear_26801_925)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.2818 70.6889V51.3553C80.2818 48.9825 82.2111 47.0588 84.591 47.0588H75.9725C73.5925 47.0588 71.6631 48.9825 71.6631 51.3553V70.6889C71.6631 73.0617 73.5925 74.9853 75.9725 74.9853H84.591C82.2111 74.9853 80.2818 73.0617 80.2818 70.6889Z",
    fill: "url(#paint4_linear_26801_925)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.232 57.2155H81.3968C80.5303 57.2155 79.8281 56.5154 79.8281 55.6515C79.8281 54.7876 80.5303 54.0876 81.3968 54.0876H130.232C131.098 54.0876 131.8 54.7876 131.8 55.6515C131.8 56.5154 131.098 57.2155 130.232 57.2155Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.814 67.9563H81.3968C80.5303 67.9563 79.8281 67.2563 79.8281 66.3924C79.8281 65.5284 80.5303 64.8284 81.3968 64.8284H105.814C106.681 64.8284 107.383 65.5284 107.383 66.3924C107.383 67.2563 106.68 67.9563 105.814 67.9563Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.803,
    cy: 60.0157,
    rx: 9.87688,
    ry: 9.84723,
    fill: "url(#paint5_linear_26801_925)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.727 59.0271C144.104 58.6511 144.716 58.6511 145.093 59.0271L147.961 61.8868L153.834 56.0312C154.212 55.6552 154.823 55.6552 155.2 56.0312C155.577 56.4073 155.577 57.0169 155.2 57.393L148.644 63.9295C148.267 64.3056 147.655 64.3056 147.278 63.9295L143.727 60.3889C143.35 60.0129 143.35 59.4032 143.727 59.0271Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5806 47.0588H37.1888C34.8088 47.0588 32.8794 48.9825 32.8794 51.3553V70.6889C32.8794 73.0617 34.8088 74.9853 37.1888 74.9853H56.5806C58.9605 74.9853 60.89 73.0617 60.89 70.6889V51.3553C60.89 48.9825 58.9605 47.0588 56.5806 47.0588ZM54.4259 68.5406H39.3433V53.5033H54.4259V68.5406Z",
    fill: "url(#paint6_linear_26801_925)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.962 153.824H77.382C74.0491 153.824 71.3472 151.896 71.3472 149.518V130.142C71.3475 127.764 74.0491 125.837 77.382 125.837H160.962C164.295 125.837 166.997 127.764 166.997 130.142V149.518C166.997 151.896 164.295 153.824 160.962 153.824Z",
    fill: "url(#paint7_linear_26801_925)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.2818 149.467V130.133C80.2818 127.76 82.2111 125.837 84.591 125.837H75.9725C73.5925 125.837 71.6631 127.76 71.6631 130.133V149.467C71.6631 151.84 73.5925 153.763 75.9725 153.763H84.591C82.2111 153.763 80.2818 151.84 80.2818 149.467Z",
    fill: "url(#paint8_linear_26801_925)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.232 135.993H81.3968C80.5303 135.993 79.8281 135.293 79.8281 134.429C79.8281 133.565 80.5303 132.865 81.3968 132.865H130.232C131.098 132.865 131.8 133.565 131.8 134.429C131.8 135.293 131.098 135.993 130.232 135.993Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_26801_925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.814 146.734H81.3968C80.5303 146.734 79.8281 146.034 79.8281 145.17C79.8281 144.306 80.5303 143.606 81.3968 143.606H105.814C106.681 143.606 107.383 144.306 107.383 145.17C107.383 146.034 106.68 146.734 105.814 146.734Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.803,
    cy: 138.794,
    rx: 9.87688,
    ry: 9.84723,
    fill: "url(#paint9_linear_26801_925)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.727 137.805C144.104 137.429 144.716 137.429 145.093 137.805L147.961 140.665L153.834 134.809C154.212 134.433 154.823 134.433 155.2 134.809C155.577 135.185 155.577 135.795 155.2 136.171L148.644 142.707C148.267 143.083 147.655 143.083 147.278 142.707L143.727 139.167C143.35 138.791 143.35 138.181 143.727 137.805Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5806 125.837H37.1888C34.8088 125.837 32.8794 127.76 32.8794 130.133V149.467C32.8794 151.84 34.8088 153.763 37.1888 153.763H56.5806C58.9605 153.763 60.89 151.84 60.89 149.467V130.133C60.89 127.76 58.9605 125.837 56.5806 125.837ZM54.4259 147.318H39.3433V132.281H54.4259V147.318Z",
    fill: "url(#paint10_linear_26801_925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26801_925",
    x: 67.3472,
    y: 82.4478,
    width: 103.65,
    height: 35.9869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26801_925"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26801_925",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_26801_925",
    x: 28.8794,
    y: 82.4779,
    width: 36.0105,
    height: 35.9265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26801_925"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26801_925",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_26801_925",
    x: 75.8281,
    y: 100.248,
    width: 35.5547,
    height: 11.1279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26801_925"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26801_925",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_26801_925",
    x: 79.8281,
    y: 53.0876,
    width: 51.9722,
    height: 4.12787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_925",
    result: "effect2_innerShadow_26801_925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_26801_925",
    x: 79.8281,
    y: 63.8284,
    width: 27.5547,
    height: 4.12787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_925",
    result: "effect2_innerShadow_26801_925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_26801_925",
    x: 79.8281,
    y: 131.865,
    width: 51.9722,
    height: 4.12787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_925",
    result: "effect2_innerShadow_26801_925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_26801_925",
    x: 79.8281,
    y: 142.606,
    width: 27.5547,
    height: 4.12787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_925"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_925",
    result: "effect2_innerShadow_26801_925"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_925",
    x1: 25.6001,
    y1: 36.7188,
    x2: 168.569,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_925",
    x1: 102.433,
    y1: 86.4478,
    x2: 101.561,
    y2: 113.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CD",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_925",
    x1: 41.9828,
    y1: 86.4779,
    x2: 39.0494,
    y2: 113.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CD",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_925",
    x1: 119.172,
    y1: 47.0588,
    x2: 119.172,
    y2: 75.0457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_925",
    x1: 71.6631,
    y1: 49.2406,
    x2: 90.7568,
    y2: 57.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_925",
    x1: 141.087,
    y1: 50.1685,
    x2: 163.891,
    y2: 64.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_925",
    x1: 46.8847,
    y1: 47.0588,
    x2: 46.8847,
    y2: 74.9853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_925",
    x1: 119.172,
    y1: 125.837,
    x2: 119.172,
    y2: 153.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_925",
    x1: 71.6631,
    y1: 128.018,
    x2: 90.7568,
    y2: 136.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26801_925",
    x1: 141.087,
    y1: 128.946,
    x2: 163.891,
    y2: 143.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26801_925",
    x1: 46.8847,
    y1: 125.837,
    x2: 46.8847,
    y2: 153.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoice);
export default __webpack_public_path__ + "static/media/Multiple-Choice.baf744970ecfd88d6adf6bb6f921d226.svg";
export { ForwardRef as ReactComponent };